<template>
  <v-container
    id="towerServices"
    fluid
    tag="section"
  >
    <v-card
      flat
      class="mx-0 px-4 py-4"
    >
      <v-container>
        <v-row>
          <v-col>
            <v-btn>
              Refresh
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-expansion-panels
        v-model="panel"
        multiple
      >
        <v-expansion-panel
          v-for="(tower, towerNum) in towers"
          :key="towerNum"
        >
          <v-expansion-panel-header>
            <v-row>
              <v-col
                cols="6"
              >
                <span class="section-header">{{ `${towerNum}` }}</span>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row
              class="d-flex"
            >
              <base-sq-card
                v-for="(devices, roleTitle) of tower"
                :key="`${towerNum}-${roleTitle}`"
                :title="roleTitle"
                style="width: 300px"
              >
                <v-col cols="12">
                  <v-virtual-scroll
                    height="350px"
                    :item-height="85"
                    :items="devices"
                  >
                    <template v-slot:default="{ item: device }">
                      <v-card
                        tile
                        class="mx-auto my-2 pb-2"
                      >
                        <v-list-item
                          three-line
                        >
                          <v-list-item-content>
                            <v-list-item-title>
                              <strong><a
                                :href="`http://${device.NetworkIp}`"
                                target="_blank"
                              >{{ device.Name }}</a>
                              </strong>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ device.type_model }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                              <template
                                v-if="device.NetworkIp"
                              >
                                <a
                                  :href="`http://${device.NetworkIp}`"
                                  target="_blank"
                                >{{ device.NetworkIp }}</a>
                              </template>
                              <v-btn
                                v-if="device.dash_url"
                                icon
                                :href="`${device.dash_url}`"
                                target="_blank"
                                class="my-n4 ml-2"
                              >
                                <v-icon>
                                  mdi-gauge
                                </v-icon>
                              </v-btn>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                    </template>
                  </v-virtual-scroll>
                </v-col>
              </base-sq-card>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </v-container>
</template>

<script>
  import {
  } from '../../../store/actions.types'
  import InventoryService from '../../../services/inventory.service'
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'TowersInventory',
    components: {
      // powAccessPointForm: () => import('@/components/pow/AccessPointForm'),
      // powTowerAccessPoints: () => import('@/components/pow/TowerAccessPoints'),
      // powTowerSubscribers: () => import('@/components/pow/TowerSubscribers'),
    },
    mixins: [basicMixin],
    data () {
      return {
        panel: [],
        towers: {},
      }
    },
    computed: {
    },
    async created () {
      console.log('page loaded')
      console.log(this.$route)
      // if (this.$route.params.account) {
      //   this.selectedAccount = this.$route.params.account
      // } else if (this.$route.params.key) {
      //   const payload = {
      //     key: this.$route.params.key,
      //     params: this.$route.query,
      //   }
      //   this.selectedAccount = await this.getAccount(payload)
      // }
      await this.doGetInfra()
    },
    mounted () {

      // const queryParams = this.$route.params
    },
    methods: {
      async doGetInfra () {
        try {
          const { data } = await InventoryService.getInfra()
          console.log('Tower Data', data)
          this.towers = data
        } catch (e) {
          console.log(e)
        }
      },
    },
  }
</script>
<style>
  .ps {
    position: relative;
    height: 400px;
  }
</style>
